import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import isEmpty from 'src/app/lib/isEmpty';
import { GridBotService } from 'src/app/services/bot.grid.service';

// Import facade
import { PairFacade } from '../../store/botpair'
import { AuthFacade } from 'src/app/store/auth';
import { WalletService } from 'src/app/services/wallet.service';
import { TradeAssetFacade } from 'src/app/store/bot-trade-asset';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { Store } from '@ngrx/store';
import { SocketService } from 'src/app/services/socket.service';
import { dateTimeFormat } from 'src/app/lib/dateFilter';
import { firstCapital } from 'src/app/lib/capital';
import { toFixed, toFixedDown } from 'src/app/lib/roundOf';
import { botSocket, spotSocket, GridSocket } from 'src/app/app.module';
// import { TradeAssetFacade } from 'src/app/store/trade-asset';
import { MarketPriceFacade } from 'src/app/store/marketprice';

@Component({
  selector: 'app-gridbot',
  templateUrl: './gridbot.component.html',
  styleUrls: ['./gridbot.component.css'],
})
export class GridbotComponent {
  @Output() orderStep: any = 'one'
  @Output() gotoStep = new EventEmitter<any>();
  isChecked: boolean = false;
  isChecked2: boolean = false;
  selectedDate: Date | null = null;
  isEmpty = isEmpty
  dateTimeFormat = dateTimeFormat
  firstCapital = firstCapital
  toFixedDown = toFixedDown
  toFixed = toFixed
  tikerRoot: any
  auth: any = {}
  pairData: any = {}
  posDetails: any = {}
  chartData: any = {}
  pairList: any = []
  chartStatus = false
  public isMobileLayout = false;
  public isDestopLayout = false;
  selectedBot: any;
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private service: GridBotService,
    private router: Router,
    private pairFacade: PairFacade,
    private botFacade: TradePairFacade,
    private authFacade: AuthFacade,
    private walletService: WalletService,
    private tradeAssetFacade: TradeAssetFacade,
    private spotSocket: spotSocket,
    private botSocket: botSocket,
    private grirScoket: GridSocket,
    private socketService: SocketService,
    private store: Store<{ positionDetails: PositionDetailsFacade }>,
    private marketPriceFacade: MarketPriceFacade,

  ) {
    this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    })
  }
  ngOnInit() {

    this.getPairs()
    this.orderStep = 'one'
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1199;
    window.onload = () => this.isMobileLayout = window.innerWidth <= 1199;
    this.route.paramMap.subscribe(params => {
      this.tikerRoot = params.get('tikerRoot');

      if (!isEmpty(this.tikerRoot)) {
        this.socketService.emit("subscribe", this.tikerRoot.replace("_", ""));
      }
    });

    this.getCurrPair();

    this.store.select('positionDetails').subscribe((posDet: any) => {
      // console.log(posDet.positionDetails, '---------59',isEmpty(posDet.positionDetails))
      this.posDetails = posDet.positionDetails;
      // this.getBotHistoryCall(posDet.positionDetails)
    });


    this.spotSocket.on('marketPrice', this.marketPriceWs.bind(this))


  }

  //get redux data
  getCurrPair() {
    this.botFacade.tradePair$.subscribe({
      next: (pair: any) => {
        this.pairData = pair
      },
      error: (err: any) => { }
    })
  }

  fetchOHWS(result: any) {
    this.fetchDCAChart(this.pairData)
    this.fetchAssetByCurrency(this.pairData.secondCurrencyId, 'secondCurrency')
  }

  marketPriceWs(result: any) {
    if (result.pairId == this.pairData._id) {
      this.marketPriceFacade.setSpotMarketPrice(result.data)
    }
  }

  ngOnDestroy() {
    if (!isEmpty(this.tikerRoot)) {
      this.socketService.emit("unSubscribe", this.tikerRoot.replace("_", ""));
    }
  }
  getPairs() {
    this.service.getPairList()
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            if (isEmpty(this.tikerRoot)) {
              let pair = `${v.result[0].firstCurrencySymbol}_${v.result[0].secondCurrencySymbol}`
              this.router.navigateByUrl("/gridbot/" + pair)
            } else {
              this.pairFacade.setPair(v.result)
              const selectedPair = v.result.find((el: any) => el.tikerRoot === this.tikerRoot.replace('_', ''))
              if (isEmpty(selectedPair)) {
                window.location.href = '/gridbot/'
              }
              this.pairList = v.result
              this.pairData = selectedPair;
              this.marketPriceFacade.setSpotMarketPrice(selectedPair)
              this.fetchAssetByCurrency(selectedPair.secondCurrencyId, 'secondCurrency')
              this.service.setTradePair(selectedPair)
              this.fetchDCAChart(selectedPair)
              this.grirScoket.on('positionHistory', this.fetchOHWS.bind(this))
            }
          }
        },
        error: (err: any) => {
        }
      })
  }
  fetchDCAChart(selectedPair: any) {
    this.service.getOpenOChart({
      pair: selectedPair?.tikerRoot ?? this.pairData?.tikerRoot,
      pairId: selectedPair?._id ?? this.pairData?._id,
      exchange: selectedPair?.botstatus ?? "running",
    }).subscribe({
      next: (v: any) => {
        this.chartStatus = true
        this.chartData = v.result
      },
      error: (err: any) => {
      },
      complete: () => { },
    });
  }

  fetchAssetByCurrency(spotPairId: string, type: 'firstCurrency' | 'secondCurrency') {
    if (!this.auth.signedIn)
      return
    this.walletService.getAssetByCurrency(spotPairId)
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            if (type === 'firstCurrency')
              this.tradeAssetFacade.setFirstCurrency(v.result)
            else if (type === 'secondCurrency')
              this.tradeAssetFacade.setSecondCurrency(v.result)
          }
        },
        error: (err: any) => {
        }
      })
  }


  // ui to open bot details
  onBotSelected(bot: any) {
    this.orderStep = '';
    setTimeout(() => {
      this.orderStep = 'three';
    });
    this.selectedBot = { ...this.selectedBot, ...bot }
    let selectedPair = this.pairList.find((el: any) => el._id === this.selectedBot?.pairId)
    let pair = `${selectedPair.firstCurrencySymbol}_${selectedPair.secondCurrencySymbol}`
    if (this.tikerRoot != pair) {
      this.location.go('/gridbot/' + pair);
      this.pairData = selectedPair;
      this.marketPriceFacade.setSpotMarketPrice(selectedPair)
      this.fetchAssetByCurrency(selectedPair.secondCurrencyId, 'secondCurrency')
      this.service.setTradePair(selectedPair)
      this.fetchDCAChart(selectedPair)
      this.grirScoket.on('positionHistory', this.fetchOHWS.bind(this))
    }
  }

}
